export default "__VITE_ASSET__f53f7115__"